import React, { createContext } from 'react';

const EmailAppContext = createContext({});

export { EmailAppContext };
